import styled from 'styled-components';

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  color: #1b1b1b;
`;

export const LinkStyle = styled.span`
  color: #0052a5;
  font-weight: bold;
`;
